import styled, { css } from 'styled-components';
import { rem } from 'polished';
import SpriteIcon from './SpriteIcon';
import SpriteIconPng from './SpriteIconPng';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledIconContainer = styled.div`
  ${props =>
    props.counter > 0 &&
    css`
      position: relative;
    `};
`;

const StyledIcon = styled(SpriteIcon)`
  ${props =>
    props.size &&
    css`
      width: ${props.theme.icons[props.size].width};
      height: ${props.theme.icons[props.size].height};
    `};
  ${props =>
    props.color &&
    css`
      fill: ${props.theme.colors[props.color]};
    `};
  ${props =>
    props.hover &&
    css`
      &:hover {
        fill: ${props.theme.colors.primary};
        cursor: pointer;
      }
    `};
  transition: 0.5s;
`;

const StyledIconPng = styled(SpriteIconPng)`
  ${props =>
    props.size &&
    css`
      width: ${props.theme.icons[props.size].width};
      height: ${props.theme.icons[props.size].height};
    `};
  ${props =>
    props.color &&
    css`
      fill: ${props.theme.colors[props.color]};
    `};
  ${props =>
    props.hover &&
    css`
      &:hover {
        fill: ${props.theme.colors.primary};
        cursor: pointer;
      }
    `};
  transition: 0.5s;
`;

// Capa para el icono comentarios
const StyledIconComments = styled.svg`
  ${props =>
    props.size &&
    css`
      width: ${props.theme.icons[props.size].width};
      height: ${props.theme.icons[props.size].height};
    `};
  ${props =>
    props.color &&
    css`
      fill: ${props.theme.colors[props.color]};
    `};
  ${props =>
    props.hover &&
    css`
      &:hover {
        fill: ${props.theme.colors.primary};
        cursor: pointer;
      }
    `};
  transition: 0.5s;
`;

// Capa para el numero del icono comentarios
const StyledText = styled.text`
  font-family: ${props => props.theme.fonts.bold};
  font-size: 0.6875rem;
  letter-spacing: -0.01875rem;
  display: ${props => props.center === true && 'block'};
  text-align: ${props => props.center === true && 'center'};
  width: ${props => props.mobile === true && '80%'};
  font-size: ${props => props.mobile === true && 'larger'};
  ${props =>
    props.center === true &&
    mediaqueries.lessThan('720px')`
    margin-top: -5px;
    margin-right: 22px;
    width: ${props => props.mobile === true && '384px'};
  `};
  ${props =>
    props.center === true &&
    mediaqueries.greaterThan('mobile')`
      margin-right: 33px;
      margin-top: -5px;
    `};
  ${props =>
    props.center === true &&
    mediaqueries.greaterThan('desktop')`
    margin-top: ${props.menu === true ? '0px' : '10px'};
    margin-right: 50px;
    margin-left: ${props.menu === true && '100px'};
  `};
`;

const StyledIconCounter = styled.span`
  position: absolute;
  right: ${rem('-15px')};
  top: -0.25rem;
  width: ${rem('17px')};
  height: ${rem('17px')};
  line-height: ${rem('17px')};
  font-size: ${rem('10px')};
  text-align: center;
  border-radius: 100%;
  font-family: ${props => props.theme.fonts.bold};
  background: black;
  color: white;
  text-overflow: clip;
  white-space: nowrap;
  overflow: hidden;
  pointer-events: none;
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('11px')};
    width: ${rem('18px')};
    height: ${rem('18px')};
    line-height: ${rem('18px')};
  `};
  ${props =>
    props.counter >= 100 &&
    css`
      width: ${rem('20px')};
      height: ${rem('20px')};
      line-height: ${rem('20px')};
      ${mediaqueries.greaterThan('desktop')`
        width: ${rem('21px')};
        height: ${rem('21px')};
        line-height: ${rem('21px')};
      `};
    `};
`;

export {
  StyledIconContainer,
  StyledIcon,
  StyledIconPng,
  StyledIconComments,
  StyledText,
  StyledIconCounter
};
